module.exports = __webpack_public_path__ + "img/a_Kyurkchiev.e631debf.jpg";